// extracted by mini-css-extract-plugin
export default {"searchbar":"MunicipalitySearchbar_searchbar__Msn2g"};